import { render, staticRenderFns } from "./ChatClosedOverlay.vue?vue&type=template&id=1159c8b8&"
import script from "./ChatClosedOverlay.vue?vue&type=script&lang=js&"
export * from "./ChatClosedOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports